import { IPredicateFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';
import SimpleFilterPredicate from './SimpleFilterPredicate';

interface IProps {
  predicate: IPredicateFieldsFragment;
  keyPrefix: string;
}

const BasicFilterPredicate = ({ predicate, keyPrefix }: IProps) => {
  if (predicate.__typename === 'SimplePredicate') {
    return (
      <SimpleFilterPredicate predicate={predicate} keyPrefix={keyPrefix} />
    );
  } else if (predicate.__typename === 'ArrayObjectPredicate') {
    return (
      <>
        {predicate.elementPredicates.map(
          (elementPredicate, elementPredicateIndex) => (
            <>
              {elementPredicateIndex > 0 ? <>, includes </> : null}
              <SimpleFilterPredicate
                key={`${keyPrefix}-element-${elementPredicateIndex}`}
                predicate={elementPredicate}
                keyPrefix={`${keyPrefix}-element-${elementPredicateIndex}`}
              />
            </>
          ),
        )}
      </>
    );
  } else {
    return null;
  }
};

export default BasicFilterPredicate;
